import { onSnapshot } from 'firebase/firestore'

import { docRef } from './documents'

/**
 * Live-subscribes to one employer's logo URL (#407), for the header badge.
 * Deliberately a plain onSnapshot rather than the Suspense-based useDocument
 * in services/data.js: the header renders above <Routes/> with no Suspense or
 * error boundary around it (see src/App.js), so a throwing read there would
 * take down the whole app for every page load — a branding badge must never
 * do that. `onError` is expected to treat a failed read as "no logo".
 */
export function subscribeToEmployerLogo(employerId, onLogoUrl, onError) {
  return onSnapshot(
    docRef('employers', employerId),
    snapshot => onLogoUrl(snapshot.data()?.logoUrl || null),
    onError
  )
}
